import { render, staticRenderFns } from "./CRUDTableDetail.vue?vue&type=template&id=d35cf75c"
import script from "./CRUDTableDetail.vue?vue&type=script&lang=js"
export * from "./CRUDTableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports